var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogout = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#15206b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.5 10.5h-8.87249l3.49999 3.5-3.49999-3.5 3.49999-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.50263 17.4826h-3.64876c-.24663.0023-.4913-.0441-.71994-.1366-.22863-.0926-.43673-.2293-.61235-.4025s-.3153-.3794-.41101-.6067-.14556-.4713-.1467-.718v-10.22869c-.00001-.24664.04872-.49087.14336-.71863.09465-.22775.23338-.43451.40819-.6085.1748-.17399.38226-.31177.61045-.40535.22819-.09359.47261-.14118.71924-.14003h3.78001"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logout.b1752e2991e9e3e360125b43de7c0ca0.svg";